import { render } from "./AuditResultTable.vue?vue&type=template&id=6061b3ea&scoped=true&ts=true"
import script from "./AuditResultTable.vue?vue&type=script&lang=ts"
export * from "./AuditResultTable.vue?vue&type=script&lang=ts"

import "./AuditResultTable.vue?vue&type=style&index=0&id=6061b3ea&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6061b3ea"]])

export default __exports__